import '../login/LoginPage.css';
import { Field, Form, Formik } from 'formik';
import FormikFieldInputGroup from '../../components/form/formik/FormikFieldInputGroup';
import { Button, Spinner } from 'react-bootstrap';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { recoverPassword } from '../../api/ApiEndpoints';
import { useState } from 'react';

export const RememberPassword = () => {

    const { t } = useTranslation('rememberPassword');
    const alert = useAlert();
    const [sent, setSent] = useState(false);

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(t('validations:notEmail'))
            .required(t('validations:required')),
    });

    const onSubmit = (form, helper) => {
        recoverPassword(form.email)
            .then(() => {
                setSent(true);
                alert.success(t('alert:sendSuccess'));
            })
            .catch(() => alert.error(t('alert:sendFailure')))
            .finally(() => helper.setSubmitting(false));
    };

    return (
        <Formik
            initialValues={{
                email: '',
            }}
            onSubmit={(email, helper) => onSubmit(email, helper)}
            validationSchema={validationSchema}
        >
            {(props) => {
                return (
                    <div className='login_style'>
                        <div className='login_text center'>
                            <h1>{t('common:appName')}</h1>
                        </div>
                        <div className='login_box'>
                            <div><span>{t('title')}</span></div>
                            <Form className={'login_form'}>
                                <Field
                                    name='email'
                                    labelText={t('email')}
                                    type='text'
                                    component={FormikFieldInputGroup}
                                />
                                <div className='text-center'>
                                    {props.isSubmitting ? (
                                        <Button variant='primary' disabled>
                                            <Spinner
                                                as='span'
                                                animation='grow'
                                                size='sm'
                                                role='status'
                                                aria-hidden='true'
                                            />
                                            {t('common:buttons.processing')}
                                        </Button>
                                    ) : (
                                        <Button type='submit' variant='primary' disabled={sent}>
                                            {t('common:buttons.send')}
                                        </Button>
                                    )}
                                </div>
                            </Form>
                        </div>
                    </div>
                );
            }}
        </Formik>
    );
};